import { render } from "./CardMenu.vue?vue&type=template&id=256505f1"
import script from "./CardMenu.vue?vue&type=script&lang=js"
export * from "./CardMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__